import { render, staticRenderFns } from "./MentoringProfit.vue?vue&type=template&id=470cdd43&scoped=true&"
import script from "./MentoringProfit.vue?vue&type=script&lang=js&"
export * from "./MentoringProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470cdd43",
  null
  
)

export default component.exports